import { useQuery } from '@tanstack/vue-query';
import { dscvrIcApi } from '@/shared/api';

export const useGetPurchasableAwardsQuery = () => {
  return useQuery({
    queryKey: ['get-purchasable-awards'],
    queryFn: dscvrIcApi.igc.getPurchasableAwards,
  });
};
